import { FC, ReactNode } from 'react'
import Navbar from './Navbar'

const Layout: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div className="min-w-screen overflow-hidden flex flex-col pt-16">
      <Navbar />
      {children}
    </div>
  )
}

export default Layout
